<template>
  <Modal>
    <Modal.Media full-bleed>
      <div class="flex justify-center pt-[43px] pb-[18px] tablet-v:pt-[48px]">
        <div class="w-[221px] tablet-v:w-[265px]">
          <MembershipCard
            :name="userName"
            :variant="cardVariant"
            interactive
            shadow
            class="relative w-full"
          />
        </div>
      </div>
    </Modal.Media>
    <Modal.Title>Welcome to your<br />Dacr {{ membershipName }}</Modal.Title>
    <Modal.Body>
      Take advantage of all benefits your membership has to offer. Register your
      first work today.
    </Modal.Body>
    <Modal.Footer layout="vertical">
      <Button variant="primary" size="lg" @click="close()">Continue</Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Modal, Button, useModal } from '@dacr/library'

import MembershipCard from '@/shared/components/MembershipCard.vue'
import { useBillingStore } from '@/features/billing/store'
import { MembershipTier } from '@/shared/graphql/legacy/generated'
import { useUserStore } from '@/shared/stores/user'

const props = defineProps<{ membershipTier?: MembershipTier | null }>()

const { close } = useModal()
const userStore = useUserStore()
const billingStore = useBillingStore()

const userName = computed(() => userStore.user?.name ?? 'Jessica Ramsey')
const tier = computed(
  () =>
    props.membershipTier ?? billingStore.membershipTier ?? MembershipTier.Pro
)
const cardVariant = computed(() =>
  tier.value === MembershipTier.Basic ? 'basic' : 'pro'
)
const membershipName = computed(() =>
  tier.value === MembershipTier.Basic ? 'Basic Membership' : 'Pro Membership'
)
</script>
